module.exports = __webpack_public_path__ + "media/images/icons/energie-icons-search-fill-2955b2ec123ff1c63e4ce9e3fbde50bd.svg";